<template>
  <div class="notice-edit">
    <div class="notice-edit-body">
      <aside class="pane palette">
        <div class="pane-title">添加组件</div>
        <div class="comp-grid">
          <button type="button" class="comp-btn" @click="addComponent('map')">地图</button>
          <button type="button" class="comp-btn" @click="addComponent('audio')">音频</button>
          <button type="button" class="comp-btn" @click="addComponent('vedio')">视频</button>
          <button type="button" class="comp-btn" @click="addComponent('img')">图片</button>
          <button type="button" class="comp-btn" @click="addComponent('link')">链接</button>
          <button type="button" class="comp-btn" @click="addComponent('input')">输入框</button>
          <button type="button" class="comp-btn" @click="addComponent('btn')">按钮</button>
        </div>

        <div class="pane-title">重要程度</div>
        <el-radio-group v-model="noticeTemplate.emergency" class="radio-stack">
          <el-radio v-for="emc in emergencyObjs" :key="emc.value" :label="emc.value">{{
            emc.label
          }}</el-radio>
        </el-radio-group>

        <div class="pane-title">需要确认</div>
        <el-radio-group v-model="noticeTemplate.needConfirm" class="radio-stack">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>

        <div class="pane-title">仅管理员发送</div>
        <el-radio-group v-model="noticeTemplate.adminSend" class="radio-stack">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>

        <div class="pane-title">接收对象</div>
        <div class="side-field">
          <div class="side-label">选择车队</div>
          <el-select
            v-model="noticeTemplate.receiverTeam"
            placeholder="请选择接收车队"
            clearable
            multiple
            collapse-tags
            style="width: 100%"
          >
            <el-option
              v-for="item in teamOpts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="side-field">
          <div class="side-label">选择司机</div>
          <el-input v-model="noticeTemplate.receiver" placeholder="司机编号，逗号分隔"></el-input>
        </div>
      </aside>

      <section class="pane preview">
        <el-form label-width="88px" size="small" class="base-form" @submit.native.prevent>
          <el-form-item label="模板编码">
            <el-input
              v-model="noticeTemplate.code"
              placeholder="系统自动生成"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="模板名称" required>
            <el-input v-model="noticeTemplate.name" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label="模板分类">
            <el-select v-model="noticeTemplate.flCode" placeholder="请选择模板分类" clearable style="width: 100%">
              <el-option
                v-for="item in templateFlObj"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" required>
            <el-input v-model="noticeTemplate.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="副标题">
            <el-input v-model="noticeTemplate.subTitle" placeholder="请输入副标题"></el-input>
          </el-form-item>
          <el-form-item label="发送内容" required>
            <el-input
              type="textarea"
              :rows="4"
              v-model="noticeTemplate.content"
              placeholder="请输入发送内容"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="comp-list" v-if="componentCount">
          <div
            v-for="(field, i) in noticeTemplate.fields"
            :key="field.id || 'field-' + i"
            class="comp-card"
            :class="{ active: currentCfg === field }"
            @click="editComponent(field, i)"
          >
            <div class="comp-card-head">
              <span>{{ typeLabel(field.type) }}</span>
              <span class="comp-card-id" v-if="field.id">{{ field.id }}</span>
            </div>
            <div class="comp-card-body">
              <template v-if="field.type == 'map'">
                <el-image class="map-thumb" :src="mapThumb" fit="cover"></el-image>
                <div class="comp-text">{{ field.value || "未填写地址" }}</div>
                <div class="comp-sub" v-if="field.lng || field.lat">{{ field.lng }} , {{ field.lat }}</div>
              </template>
              <template v-else-if="field.type == 'img'">
                <div v-if="mediaUrls(field.value).length" class="media-grid">
                  <el-image
                    v-for="(url, idx) in mediaUrls(field.value)"
                    :key="url + idx"
                    class="media-thumb"
                    :src="url"
                    :preview-src-list="mediaUrls(field.value)"
                    fit="cover"
                  ></el-image>
                </div>
                <div v-else class="media-empty">未上传图片</div>
              </template>
              <template v-else-if="field.type == 'audio'">
                <div v-if="mediaUrls(field.value).length" class="media-stack">
                  <audio
                    v-for="(url, idx) in mediaUrls(field.value)"
                    :key="url + idx"
                    :src="url"
                    controls
                    class="media-player"
                  ></audio>
                </div>
                <div v-else class="media-empty">未上传音频</div>
              </template>
              <template v-else-if="field.type == 'vedio'">
                <div v-if="mediaUrls(field.value).length" class="media-stack">
                  <video
                    v-for="(url, idx) in mediaUrls(field.value)"
                    :key="url + idx"
                    :src="url"
                    controls
                    class="media-player"
                  ></video>
                </div>
                <div v-else class="media-empty">未上传视频</div>
              </template>
              <template v-else-if="field.type == 'link'">
                <div class="comp-text">{{ field.tip || "未填写显示文字" }}</div>
                <el-link type="primary">{{ field.name || "跳转文字" }}</el-link>
                <div class="comp-sub">{{ field.value || "未填写跳转地址" }}</div>
              </template>
              <template v-else-if="field.type == 'input'">
                <div class="comp-text">{{ field.name || "未填写输入标题" }}</div>
                <div class="fake-input">{{ field.tip || "请输入" }}</div>
                <div class="fake-btn">{{ field.btnName || "提交" }}</div>
              </template>
              <template v-else>
                <div class="comp-text">{{ field.name || field.value || "未命名组件" }}</div>
              </template>
            </div>
          </div>

          <div
            v-for="(btn, i) in noticeTemplate.btns"
            :key="btn.id || 'btn-' + i"
            class="comp-card"
            :class="{ active: currentCfg === btn }"
            @click="editComponent(btn, i)"
          >
            <div class="comp-card-head">
              <span>按钮</span>
              <span class="comp-card-id" v-if="btn.id">{{ btn.id }}</span>
            </div>
            <div class="comp-card-body">
              <el-button size="small">{{ btn.name || "按钮" }}</el-button>
              <div class="comp-sub" v-if="btn.value">值：{{ btn.value }}</div>
            </div>
          </div>
        </div>
        <div v-else class="comp-empty">还没有组件，从左侧添加地图、图片、链接或按钮</div>
      </section>

      <aside class="pane props">
        <div class="pane-title">
          属性设置
          <span v-if="currentCfg.id" class="comp-card-id">{{ currentCfg.id }}</span>
        </div>
        <div v-if="current == -1" class="props-empty">
          <el-empty description="请选择组件" :image-size="80"></el-empty>
        </div>
        <el-form v-else label-width="88px" size="small" class="props-form" @submit.native.prevent>
          <template v-if="currentCfg.type == 'map'">
            <el-form-item label="纬度">
              <el-input v-model="currentCfg.lat"></el-input>
            </el-form-item>
            <el-form-item label="经度">
              <el-input v-model="currentCfg.lng"></el-input>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input v-model="currentCfg.value"></el-input>
            </el-form-item>
          </template>

          <template v-else-if="currentCfg.type == 'img' || currentCfg.type == 'vedio' || currentCfg.type == 'audio'">
            <el-form-item label="附件">
              <file-upload
                multiple
                :filePath="$ossPath.kefuWecom()"
                v-model="currentCfg.value"
              ></file-upload>
              <div class="hint">可一次上传多个，展示数量以实际上传为准</div>
            </el-form-item>
          </template>

          <template v-else-if="currentCfg.type == 'link'">
            <el-form-item label="显示文字">
              <el-input v-model="currentCfg.tip"></el-input>
            </el-form-item>
            <el-form-item label="跳转文字">
              <el-input v-model="currentCfg.name"></el-input>
            </el-form-item>
            <el-form-item label="跳转地址">
              <el-input v-model="currentCfg.value"></el-input>
            </el-form-item>
            <el-form-item label="跳转参数">
              <el-input v-model="currentCfg.args"></el-input>
            </el-form-item>
          </template>

          <template v-else-if="currentCfg.type == 'input'">
            <el-form-item label="输入标题">
              <el-input v-model="currentCfg.name"></el-input>
            </el-form-item>
            <el-form-item label="输入提示语">
              <el-input v-model="currentCfg.tip"></el-input>
            </el-form-item>
            <el-form-item label="提交按钮">
              <el-input v-model="currentCfg.btnName"></el-input>
            </el-form-item>
          </template>

          <template v-else-if="currentCfg.type == 'btn'">
            <el-form-item label="按钮名称">
              <el-input v-model="currentCfg.name"></el-input>
            </el-form-item>
            <el-form-item label="按钮值">
              <el-input v-model="currentCfg.value"></el-input>
            </el-form-item>
          </template>

          <el-button class="remove-btn" type="danger" plain @click="removeCfg">删除此组件</el-button>
        </el-form>
      </aside>
    </div>

    <div class="notice-edit-footer">
      <el-button @click="closeWindow">取消</el-button>
      <el-button type="primary" @click="saveNotice">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeSet",
  props: ["notice"],
  data() {
    return {
      teamOpts: [],
      noticeTypeEnums: [],
      emergencyObjs: [],
      templateFlObj: [],
      hydrating: false,
      mapThumb: (process.env.BASE_URL || "/") + "static/image/map.png",
      metas: {
        map: { id: "", type: "map", value: "", lat: "", lng: "", expired: "" },
        img: { id: "", type: "img", value: "", expired: "" },
        audio: { id: "", type: "audio", value: "", expired: "" },
        vedio: { id: "", type: "vedio", value: "", expired: "" },
        link: { id: "", type: "link", value: "", args: "", name: "跳转到", tip: "", expired: "" },
        input: { id: "", type: "input", value: "", name: "", btnName: "提交", tip: "请输入", expired: "" },
        btn: { id: "", type: "btn", name: "按钮", value: "", expired: "" }
      },
      noticeTemplate: {
        fields: [],
        btns: [],
        adminSend: false,
        needConfirm: false,
        emergency: "1",
        flCode: "",
        receiverTeam: [],
        receiver: ""
      },
      currentCfg: {},
      current: -1
    };
  },
  computed: {
    componentCount() {
      const fields = (this.noticeTemplate.fields && this.noticeTemplate.fields.length) || 0;
      const btns = (this.noticeTemplate.btns && this.noticeTemplate.btns.length) || 0;
      return fields + btns;
    }
  },
  mounted() {
    this.noticeTypeEnums = window.noticeTypes;
    this.emergencyObjs = window.emergencyObjs;
    this.templateFlObj = window.flCodeOpts || [];
    this.initPage();
  },
  watch: {
    "noticeTemplate.needConfirm": function (val) {
      if (this.hydrating) {
        return;
      }
      this.unsetCfg();
      if (val) {
        this.noticeTemplate.btns = [
          {
            id: new Date().getTime(),
            type: "btn",
            name: "我知道了",
            value: "1",
            confirmBtn: true,
            expired: ""
          }
        ];
      } else {
        this.noticeTemplate.btns = [];
      }
    }
  },
  methods: {
    emptyTemplate() {
      return {
        fields: [],
        btns: [],
        adminSend: false,
        needConfirm: false,
        emergency: "1",
        flCode: "",
        receiverTeam: [],
        receiver: ""
      };
    },
    typeLabel(type) {
      const names = {
        map: "地图",
        img: "图片",
        audio: "音频",
        voice: "音频",
        vedio: "视频",
        video: "视频",
        link: "链接",
        input: "输入框",
        btn: "按钮"
      };
      return names[type] || "组件";
    },
    asList(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string" && value) {
        try {
          const parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    mediaUrls(value) {
      if (Array.isArray(value)) {
        return value.filter((item) => item);
      }
      if (typeof value === "string" && value) {
        return [value];
      }
      return [];
    },
    normalizeComponent(raw) {
      const field = Object.assign({}, raw || {});
      if (field.type === "voice") {
        field.type = "audio";
      } else if (field.type === "video") {
        field.type = "vedio";
      }
      if (field.type === "img" || field.type === "audio" || field.type === "vedio") {
        field.value = this.mediaUrls(field.value);
      }
      return field;
    },
    applyTemplate(data) {
      const template = Object.assign(this.emptyTemplate(), data || {});
      template.fields = this.asList(template.fields).map((field) => this.normalizeComponent(field));
      template.btns = this.asList(template.btns).map((field) => this.normalizeComponent(field));
      if (!Array.isArray(template.receiverTeam)) {
        template.receiverTeam = template.receiverTeam ? [template.receiverTeam] : [];
      }
      this.hydrating = true;
      this.noticeTemplate = template;
      this.unsetCfg();
      const first = template.fields[0] || template.btns[0];
      if (first) {
        this.editComponent(first, 0);
      }
      this.$nextTick(() => {
        this.hydrating = false;
      });
    },
    addComponent(ctyp) {
      if (this.noticeTemplate.needConfirm && ctyp == "btn") {
        this.$message.error("已有需要确认按钮，不能再增加其他按钮了。");
        return;
      } else if (ctyp == "input") {
        let fields = this.noticeTemplate.fields || [];
        let haseInputField = false;
        for (var i = 0; i < fields.length; i++) {
          if (fields[i].type == "input") {
            haseInputField = true;
            break;
          }
        }
        if (haseInputField) {
          this.$message.error("只能增加一个文本字段");
          return;
        }
      }

      let json = JSON.parse(JSON.stringify(this.metas[ctyp]));
      json.id = new Date().getTime();
      if (ctyp == "img" || ctyp == "audio" || ctyp == "vedio") {
        json.value = [];
      }
      if (ctyp == "btn") {
        this.noticeTemplate.btns.push(json);
        this.editComponent(json, this.noticeTemplate.btns.length - 1);
      } else {
        this.noticeTemplate.fields.push(json);
        this.editComponent(json, this.noticeTemplate.fields.length - 1);
      }
    },
    editComponent(field, i) {
      this.currentCfg = field;
      this.current = i;
    },
    removeCfg() {
      if (this.current >= 0) {
        if (this.currentCfg.type == "btn") {
          this.noticeTemplate.btns.splice(this.current, 1);
        } else {
          this.noticeTemplate.fields.splice(this.current, 1);
        }
      }
      this.unsetCfg();
    },
    unsetCfg() {
      this.current = -1;
      this.currentCfg = {};
    },

    initPage() {
      this.$http.post("/admin/team/list", { _hideLoading: true }).then((res) => {
        let teams = res.data || [];
        let teamOpts = [];
        teams.forEach((team) => {
          teamOpts.push({ value: team.id, label: team.name });
        });
        this.teamOpts = teamOpts;
      });

      if (this.notice && this.notice.id) {
        let url = "/admin/notice/template/" + this.notice.id;
        this.$http.post(url, {}).then((res) => {
          this.applyTemplate(res.data);
        });
      } else {
        this.applyTemplate(this.emptyTemplate());
      }
    },

    check() {
      if (!this.noticeTemplate.name) {
        this.$message.error("模板名称不能为空");
        return false;
      }
      if (!this.noticeTemplate.title) {
        this.$message.error("标题必填");
        return false;
      }
      if (!this.noticeTemplate.content) {
        this.$message.error("内容必填");
        return false;
      }
      return true;
    },
    saveNotice() {
      if (!this.check()) {
        return;
      }
      let url = "/admin/notice/savetemplate";
      if (!this.noticeTemplate.emergency) {
        this.noticeTemplate.emergency = "1";
      }
      this.$http.post(url, this.noticeTemplate).then(() => {
        this.closeWindow();
      });
    },
    closeWindow() {
      this.$emit("closeWindow");
    }
  }
};
</script>

<style lang="less" scoped>
.notice-edit {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 168px);
  max-height: 760px;
  min-height: 520px;
}

.notice-edit-body {
  flex: 1;
  min-height: 0;
  display: flex;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.pane {
  min-height: 0;
  overflow: auto;
}

.palette {
  width: 232px;
  flex: none;
  background: #f7f8fa;
  border-right: 1px solid #e4e7ed;
}

.preview {
  flex: 1;
  padding: 16px 16px 8px;
}

.props {
  width: 320px;
  flex: none;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background: #f7f8fa;
  border-left: 1px solid #e4e7ed;

  /deep/ .upload-box,
  /deep/ .el-upload {
    display: block;
    width: 100%;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
    height: 148px;
    padding: 0 8px;
    box-sizing: border-box;
  }

  /deep/ .el-upload-dragger .el-icon-upload {
    margin: 18px 0 8px;
    font-size: 48px;
    line-height: 48px;
  }

  /deep/ .el-upload__text {
    font-size: 12px;
    line-height: 18px;
  }
}

.pane-title {
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  background: #eef1f6;
  border-bottom: 1px solid #e4e7ed;
}

.comp-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px;
}

.comp-btn {
  height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #303133;
  cursor: pointer;
}

.comp-btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background: #ecf5ff;
}

.radio-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 12px 4px;
}

.radio-stack .el-radio {
  margin: 0 0 8px;
}

.side-field {
  padding: 0 12px 12px;
}

.side-label {
  margin-bottom: 6px;
  color: #606266;
  font-size: 12px;
}

.base-form {
  width: 100%;
}

.comp-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 4px 0 12px 88px;
}

.comp-card {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
}

.comp-card.active {
  border-color: #409eff;
  box-shadow: 0 0 0 1px #409eff inset;
}

.comp-card-head {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  font-size: 12px;
  color: #606266;
  background: #f5f7fa;
}

.comp-card-id {
  margin-left: 8px;
  color: #909399;
  font-weight: 400;
}

.comp-card-body {
  padding: 10px;
}

.comp-text {
  color: #303133;
  line-height: 22px;
  word-break: break-all;
}

.comp-sub {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
}

.map-thumb,
.media-thumb {
  width: 180px;
  height: 100px;
  border-radius: 4px;
  margin-bottom: 6px;
}

.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.media-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hint {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.media-empty,
.fake-input,
.fake-btn,
.comp-empty {
  color: #909399;
}

.fake-input,
.fake-btn,
.media-empty {
  margin-top: 6px;
  padding: 8px 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
}

.fake-btn {
  margin-top: 0;
  border-top: 0;
  border-radius: 0 0 4px 4px;
  text-align: center;
  color: #606266;
}

.media-player {
  width: 100%;
  max-height: 160px;
}

.comp-empty {
  margin: 8px 0 16px 88px;
  padding: 28px 12px;
  text-align: center;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
}

.props-form {
  padding: 12px 12px 16px;
}

.props-empty {
  padding: 24px 8px;
}

.remove-btn {
  width: 100%;
  margin-top: 8px;
}

.notice-edit-footer {
  flex: none;
  padding-top: 12px;
  text-align: right;
}
</style>
